import React from "react";

const Accordian = (props) => {
  return (

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 17 17"
      fill="none"
      style={{ transform: props.rotated ? 'rotate(90deg)' : 'rotate(0deg)' }}
    >
      <path
        d="M0.5 8.5C0.5 4.08172 4.08172 0.5 8.5 0.5C12.9183 0.5 16.5 4.08172 16.5 8.5C16.5 12.9183 12.9183 16.5 8.5 16.5C4.08172 16.5 0.5 12.9183 0.5 8.5ZM6.87574 12.1243C7.11005 12.3586 7.48995 12.3586 7.72426 12.1243L10.9243 8.92426C11.1586 8.68995 11.1586 8.31005 10.9243 8.07574L7.72426 4.87574C7.48995 4.64142 7.11005 4.64142 6.87574 4.87574C6.64142 5.11005 6.64142 5.48995 6.87574 5.72426L9.65147 8.5L6.87574 11.2757C6.64142 11.5101 6.64142 11.8899 6.87574 12.1243Z"
        fill={!props.rotated? "#0db2eb":"rgb(0, 120, 212)"}
      />
    </svg>
  );
};

export default Accordian;
